import { FileAPI } from "../apis/file";

export async function postUploadFile(file: File) {
  const payload = new FormData();
  payload.append("file", file);

  const response = await fetch(FileAPI.postUploadFIle().url, {
    method: FileAPI.postUploadFIle().method,
    body: payload,
  });

  const json = await response.json();

  if (response.status !== 200) {
    console.error(json);
    return { message: "系統錯誤", isError: true };
  }

  return json;
}

export async function deleteFileByPath(path:string) {

  const response = await fetch(FileAPI.deleteFileByPath(path).url, {
    method: FileAPI.deleteFileByPath(path).method,
  });

  const json = await response.json();

  if (response.status !== 200) {
    console.error(json);
    return { message: "系統錯誤", isError: true };
  }

  return json;
}
